import { BaseStorageService } from './base'

export class PwaStorageService extends BaseStorageService {
  constructor() {
    super()
    this.storagePrefix= 'pwa_'
  }

  getItem(key) {
    key = this.storagePrefix + key
    return super.getItem(key)
  }

  setItem(key, value, expireDate = null, secure = null, sameSite = null) {
    key = this.storagePrefix + key
    return super.setItem(key, value, expireDate, secure, sameSite)
  }

  removeItem(key) {
    key = this.storagePrefix + key
    return super.removeItem(key)
  }
}
